import settings from '../settings';
import { ICollectionCreator, IPaginationResponseDto } from '../types';
import { AxiosResponse, Canceler } from 'axios';
import api from './base';

export function getAutomatedCollectionQueryResult(sql: string) {
  const uri = `${settings.getApiURI()}/collection/v2/creators/test`;

  return api.http.post(uri, {
    sql,
  });
}

export function saveAutomatedCollection(payload: Partial<ICollectionCreator>) {
  const uri = `${settings.getApiURI()}/collection/v2/creators`;

  return api.http.post(uri, payload);
}

export function editAutomatedCollection(trackingId: string, payload: Partial<ICollectionCreator>) {
  const uri = `${settings.getApiURI()}/collection/v2/creators/${trackingId}`;

  return api.http.put(uri, payload);
}

export function getAutomatedCollections(isOnboarding?: boolean): [Promise<AxiosResponse<IPaginationResponseDto<ICollectionCreator>>>, Canceler] {
  const uri = `${settings.getApiURI()}/collection/v2/creators`;
  const params = {
    isOnboarding,
  };

  return api.getWithCancel(uri, { params });
}

export function getAutomatedCollection(trackingId: string) {
  const uri = `${settings.getApiURI()}/collection/v2/creators/${trackingId}`;
  return api.getWithCancel(uri, { params: { isLive: true } });
}

export function deleteAutomatedCollection(trackingId: string) {
  const uri = `${settings.getApiURI()}/collection/v2/creators/${trackingId}`;

  return api.http.delete(uri);
}

export function toggleActiveAutomatedCollection(trackingId: string) {
  const uri = `${settings.getApiURI()}/collection/v2/creators/${trackingId}/toggle`;

  return api.http.patch(uri);
}
